import React, { Fragment } from 'react'

const Prize = () => {
  return <Fragment>Prize</Fragment>
}

export default Prize
